<template>
  <div id="app">
    <top-bar />
    <div>
      <router-view />
    </div>

    <!--    <login v-if="!getAuthLoggedIn" />-->
    <!--    <div v-else-if="!getLoading">-->
    <!--      <bodyprint-edit-view v-if="getBodyprintMode === BodyprintMode.EDIT" />-->
    <!--      <bodyprint-check-view-->
    <!--        v-else-if="getBodyprintMode === BodyprintMode.VIEW"-->
    <!--      />-->
    <!--    </div>-->
    <!--    <div v-else>-->
    <!--      <bodyprint-queue-view />-->
    <!--    </div>-->
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { BodyprintMode } from "@/enums";

import TopBar from "@/components/top-bar.vue";
// import Login from "@/components/login";
// import BodyprintQueueView from "@/components/bodyprint/bodyprint-queue-view.vue";
// import BodyprintEditView from "@/components/bodyprint/bodyprint-edit-view.vue";
// import BodyprintCheckView from "@/components/bodyprint/bodyprint-check-view.vue";

export default {
  name: "App",
  components: {
    TopBar,
    // Login,
    // BodyprintQueueView,
    // BodyprintEditView,
    // BodyprintCheckView
  },
  computed: {
    BodyprintMode() {
      return BodyprintMode;
    },
    ...mapGetters([
      "getLoading",
      "getAuthLoggedIn",
      "getAuth",
      "getQueueEmpty",
      "getBodyprintMode"
    ]),
    ...mapActions(["authcheck"])
  },
  data() {
    return {};
  },
  methods: {},
  created() {
    if (this.$route.query.token) {
      this.$store.dispatch("authenticate", this.$route.query.token);
    }

    this.$store.dispatch("authcheck");
  },
  watch: {}
};
</script>

<style></style>
